// extracted by mini-css-extract-plugin
export default {"modalHeader":"Laa-z","modalContent":"Maa-z","formWrapper":"Naa-z","fade":"Oaa-z","fade-in":"Paa-z"};